import { IntersectionType, PartialType, PickType } from '@nestjs/swagger';
import { SpBuilderNameCreatableInterface } from '../interfaces/sp-builder-name-creatable.interface';
import { SpBuilderNameDto } from './sp-builder-name.dto';
export class SpBuilderNameCreateDto
  extends IntersectionType(
    PickType(SpBuilderNameDto, ['builderId']),
    PartialType(PickType(SpBuilderNameDto, ['active'])),
  )
  implements SpBuilderNameCreatableInterface {}
